<template>
  <div class="teams-quickmeet">
    <div class="title">Quick Meet (Teams)</div>
    <div class="row">
      <input v-model="data.title" placeholder="Meeting title (optional)" :disabled="data.loading"
             @keyup.enter="createMeeting()">
      <button @click.stop="createMeeting()" :disabled="data.loading">
        {{ data.loading ? 'Creating…' : 'Create Teams Meeting' }}
      </button>
    </div>
    <div v-if="data.error" class="error">{{ data.error }}</div>
  </div>
</template>

<script setup>
  import { reactive } from 'vue'
  import axios from 'axios'

  const data = reactive({ title: '', loading: false, error: '' })

  async function createMeeting(){
    data.error = ''
    data.loading = true
    try {
      const res = await axios.post('/teams/create_meeting/', { title: data.title || 'InterAct Class' })
      window.open(res.data.join_url, '_blank')
      data.title = ''
    } catch (e) {
      data.error = e.response?.data?.error || 'Failed to create meeting.'
    } finally {
      data.loading = false
    }
  }
</script>

<style scoped>
  .teams-quickmeet{
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    justify-content: center;
    padding: 20px;
  }
  .teams-quickmeet .title{ font-weight: bold; font-size: 1.1rem; }
  .teams-quickmeet .row{ display: flex; gap: 8px; }
  .teams-quickmeet input{
    padding: 10px 12px; border: none; border-radius: 8px; font-size: 1rem; color: #222;
  }
  .teams-quickmeet button{
    padding: 10px 16px; border: none; border-radius: 8px; cursor: pointer;
    background: var(--white); color: var(--blue); font-weight: bold;
  }
  .teams-quickmeet button:disabled{ opacity: .5; cursor: not-allowed; }
  .teams-quickmeet .error{ color: #ffe; font-size: .85rem; }
</style>
